<template>
    <div id="course-list">
      <van-nav-bar
        :placeholder="true"
        :safe-area-inset-top="true"
        :fixed="true"
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
      <template #right>
        <van-icon  @click="search" name="search" size="24" />
      </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item v-model="selectedVal" :options="option" />
      </van-dropdown-menu>
      <empty v-if="courseInfo.length === 0"></empty>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="getInitData"
      >
        <course-item v-bind:courseInfo="courseInfo"></course-item>
      </van-list>
      <bottom-nav></bottom-nav>
    </div>
</template>

<script>
import CourseItem from './components/CourseItem';
import BottomNav from './components/BottomNav';
import { Empty } from '@/components';
export default {
  components: { CourseItem, BottomNav, Empty },
  name: 'AfterSchoolCourseList',
  data () {
    return {
      courseType: ['430教材', '课程资源', '课程培训'],
      courseLabelId: 0,
      title: '',
      courseInfo: [],
      loading: false,
      finished: false,
      pageNo: 1,
      option: [
        { text: '全部', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 }
      ],
      selectedVal: 0
    };
  },
  mounted () {
    // 获取传过来的参数
    let type = this.$route.params.type;
    console.log('类型', type);
    this.title = type == null ? this.courseType[0] : this.courseType[type];
    console.log('标题', this.title);
    let courseLabelIdList = [5, 3, 1];
    this.courseLabelId = type == null ? courseLabelIdList[0] : courseLabelIdList[type];
  },
  methods: {
    search () {
      this.$router.push({ name: 'PreschoolSearch' });
    },
    onClickLeft () {
      history.back();
    },
    getInitData () {
      // 获取初始化数据
      const { $http, $utils } = this;
      if (this.courseLabelId === 0) {
        $utils.toast('参数错误！');
        return;
      }
      let params = {
        channelId: 10,
        courseLabelId: this.courseLabelId,
        pageNo: this.pageNo
      };
      $http.get('course/list', { params }).then((res) => {
        console.log('*****', res);
        this.loading = false;
        this.finished = !res.data.page.isHasNext;
        this.pageNo = res.data.page.nextPage;
        this.courseInfo.push(...res.data.page.result);
      });
    }
  }
};
</script>

<style scoped>

</style>